import config from '../config/constants'
import defaults from '../config/defaults'
import statusMessages from '../config/status-messages'
import modules from '../config/modules'
import { currency, currencyInWords } from '../config/currency'
import interceptor from '../helpers/interceptor'
import validations from '../helpers/validations'

const mixins = {
  data () {
    return {
      config,
      modules,
      currency,
      v_rules: validations,
      countries: [],
      itemCategories: [],
      taxes: [],
      units: [],
      brands: [],
      isMobileApp: process.env.VUE_APP_IS_MOBILE.toString() === 'true',
    }
  },
  methods: {
    
    hasModuleAccess: interceptor.hasModuleAccess,

    getDefault (type) {
      return defaults[type] || null
    },

    notify (key, color = '') {
      
      let status = {
        message: this.getStatusMessage(key),
        color: color
      }

      status.message.length && this.$store.commit('notify', status)
    },

    notifySuccess (key) {
      this.notify(key, 'success')
    },

    notifyError (key) {
      this.notify(key, 'error')
    },

    getStatusMessage (key) {
      return statusMessages[key] || ''
    },

    isSuccessResponse (response) {
      return response && response.status === 200 && response.data && response.data.success
    },

    setPerPage (val) {
      this.$store.commit('setPerPage', val)
    },

    extend () {
      // Variables
      var $this = this
      var extended = {}
      var i = 0

      // Merge the object into the extended object
      var merge = function (obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
              // If we're doing a deep merge and the property is an object
              extended[prop] = $this.extend(extended[prop], obj[prop])
            } else {
              // Otherwise, do a regular merge
              extended[prop] = obj[prop]
            }
          }
        }
      };

      // Loop through each object and conduct a merge
      for (; i < arguments.length; i++) {
        merge(arguments[i])
      }

      return extended
    },

    mathRound (val) {
      return Math.round(val * 100) / 100
    },

    today (format) {
      return this.$moment().format(format || 'MM-DD-YYYY')
    },

    formatMysqlDate (date, format) {
      return this.$moment(date).format(format || 'MM-DD-YYYY hh:mm:ss A')
    },

    numberToWords (num) {

      if (typeof num !== 'number') return ''

      num = Math.round(num)

      let a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
      let b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];

      if ((num = num.toString()).length > 9) return '';

      let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

      if (!n) return '';

      let str = '';

      str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
      str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
      str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
      str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
      str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';

      return str;
    },

    amountToWords (val) {
      return val ? `${currencyInWords} ${this.numberToWords(val)} only.` : ''
    },

    getPageData (model="") {

      return new Promise((resolve, reject) => {

        if (!model && !this.model) {
          return reject(new Error("model should not be empty!"))
        }

        let path = `${model || this.model}/page/${this.currentPage}/${this.paginationOptions.rowsPerPage}`

        this.processing = true

        this.axios.get(path)
          .then(response => {
            let data = [],
                total = 0
            if (this.isSuccessResponse(response)) {
                total = response.data.data.total
                data = response.data.data.items
            }

            this.$store.commit('setItemsCount', total)
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
          .then(() => {
            this.processing = false
          })
      })
      
    },

    getAllData (model="") {
      
      return new Promise((resolve, reject) => {

        if (!model && !this.model) {
          return reject(new Error("model should not be empty!"))
        }

        let path = model || this.model
        let cachedData = this.getCache(path)

        if (cachedData) {
          return resolve(cachedData)
        }
          
        this.processing = true
        
        this.axios.get(path)
          .then(response => {
            let data = []
            if (this.isSuccessResponse(response)) {
              this.setCache({ key: path, data: response.data.data })
              data = response.data.data
            }

            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
          .then(() => {
            this.processing = false
          })
        
      })
    },

    delete (model="") {
      
      return new Promise((resolve, reject) => {

        if (!model && !this.model) {
          return reject(new Error("model should not be empty!"))
        }

        if (!this.deletingItem || !this.deletingItem.id) {
          return reject(new Error("deletingItem should not be empty!"))
        }

        let path = `${model || this.model}/${this.deletingItem.id}`

        this.processing = true

        this.axios.delete(path)
          .then((response) => {
            
            if (this.isSuccessResponse(response)) {
              this.notifySuccess('deleteSuccess')
              resolve(response.data)
            }
            else{
              this.notifyError('deleteError')
              reject(new Error("error deleting Item"))
            }
            
          })
          .catch((error) => {
            this.notifyError('deleteError')
            reject(error)
          })
          .then(() => {
            this.closeDeleteDialog()
            this.processing = false
          })
      })
    },

    confirmDeleteItem (item) {
      this.deletingItem = item
      this.deleteDialog = true
    },

    closeDeleteDialog () {
      this.deletingItem = null
      this.deleteDialog = false
    },

    deleteItem (items) {
      this.delete().then(() => {
        items.splice(items.indexOf(this.deletingItem), 1)
      })
    },

    filterData () {
      this.$store.commit('setPage', 1)
      this.loadPage()
    },

    setCache (data) {
      this.$store.commit('setCache', data)
    },

    getCache (key) {
      return this.cache[key] || null
    },

    getCountries () {
      this.getAllData(this.config.apis.getCountries)
        .then( response => {
          this.countries = response
        })
    },

    getStatesByCountry (country) {
      return new Promise((resolve, reject) => {
        this.processing = true
        let states = []
        this.axios.get(this.config.apis.getStatesByCountry.replace(":country", country))
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              states = response.data.data
            }
            resolve(states)
        })
        .catch((error) => {
            this.processing = false
            reject(error)
        })
      })
    },

    getItemCategories () {
      this.getAllData(this.config.apis.getItemCategories)
        .then( response => {
          this.itemCategories = response
        })
    },

    getTaxes () {
      this.getAllData(this.config.apis.getTaxes)
        .then( response => {
          this.taxes = response
        })
    },

    getUnits () {
      this.getAllData(this.config.apis.getUnits)
        .then( response => {
          this.units = response
        })
    },

    getBrands () {
      this.getAllData(this.config.apis.getBrands)
        .then( response => {
          this.brands = response
        })
    },

  },

  computed: {

    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    loggedInUser () {
      return this.$store.getters.loggedInUser
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    isSalesManager () {
      return this.$store.getters.isSalesManager
    },
    isBillingStaff () {
      return this.$store.getters.isBillingStaff
    },
    isShippingManager () {
      return this.$store.getters.isShippingManager
    },
    isShippingStaff () {
      return this.$store.getters.isShippingStaff
    },
    isAccountsStaff () {
      return this.$store.getters.isAccountsStaff
    },
    isCommissionManager () {
      return this.$store.getters.isCommissionManager
    },
    hasAdminPrivilage () {
      return this.isSuperAdmin || this.isAdmin
    },
    isProcessing () {
      return this.$store.getters.isLoading
    },
    paginationOptions () {
      return this.$store.getters.paginationOptions
    },
    currentPage () {
      return this.$store.getters.getCurrentPage
    },
    itemsCount () {
      return this.$store.getters.getItemsCount
    },
    isDistributor () {
      return this.isLoggedIn ? this.loggedInUser.branch_type === this.config.branchTypes.distributor : false
    },
    retailerId () {
      if (this.isLoggedIn) {
        return this.isDistributor || this.isSuperAdmin ? this.config.branchTypes.distributor : this.loggedInUser.branch
      }
      else{
        return null
      }
    },
    hasCreateAccess () {
      return this.hasModuleAccess(this.$route.meta.module, this.config.actions.create)
    },

    hasEditAccess () {
      return this.hasModuleAccess(this.$route.meta.module, this.config.actions.update)
    },

    hasDeleteAccess () {
      return this.hasModuleAccess(this.$route.meta.module, this.config.actions.delete)
    },

    appSettings () {
      return this.$store.getters.getAppSettings
    },

    cache () {
      return this.$store.getters.getCache
    },

  },

  filters: {

    roundValue (val) {
      return parseFloat(Math.round((val || 0) * 100) / 100).toFixed(2)
    },

  }

}

export default mixins
